import ProductDetailsList from '@/components/Product/ProductDetailsList'
import classes from "./MainProductDetails.module.scss";

const MainProductDetails = ({ productAccordionHeadersDetailsItems, harvests, isSubscription, selectedVariant }) => {
   const currentMonth = new Date().toLocaleString('en-US', { month: 'long' }).toLowerCase();

    const currentMonthSpecies = harvests
    .filter((harvest) => harvest.variantTitle === selectedVariant?.title)
    .flatMap((harvest) =>
      harvest.months
        .filter((month) => month.month.trim().toLowerCase() === currentMonth)[0]
        ?.fishArray.map((fish) => fish.species.title)
    )
    .filter(Boolean) // Filters null values or undefined
    .join(', ');

    return (
    <>
      <div className={`${classes['product__row']} container`}>
        <h1 className={classes["details-title"]}>MORE PRODUCT DETAILS</h1>
        {productAccordionHeadersDetailsItems.map((headerData, headerIndex) => (
          <ProductDetailsList
            key={`accordion-${headerData._key}-${headerIndex}`}
            fields={{
              detailsTitle: headerData.detailsTitle,
              description: headerData.description,
              detailsItems: headerData.detailsItems,
              pointsOfInterest: headerData.points,
              subtitle: headerData.subtitle,
              footer: headerData.footer
            }}
            enableToggle={true}
            expandOnLoad={false}
            showIcon={true}
            className="product-description-block"
          />
        ))}
        {harvests.length > 0 && isSubscription && (
         <ProductDetailsList
            fields={{
              detailsTitle: 'Species currently shipping',
              description:  (
                <>
                  <a 
                    href="https://sitkaseafoodmarket.com/pages/projected-harvest"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#007bff', textDecoration: 'underline' }}
                  >
                    Preview your upcoming box contents here.
                  </a>
                </>
              ),
              detailsItems: ''
            }}
            enableToggle={true}
            expandOnLoad={false}
            showIcon={true}
            className="product-description-block"
          />
        )}
      </div>
    </>
  );
};

export default MainProductDetails;